import type { JSX, ReactNode } from 'react';
import { createContext } from 'react';

export interface HcaptchaContextValue {
  siteKey: string;
  isDisabled: boolean;
}

export const HcaptchaContext = createContext<HcaptchaContextValue | null>(null);

interface HcaptchaProviderProps {
  siteKey: string;
  isDisabled?: boolean;
  children: ReactNode;
}

export const HcaptchaProvider = ({ siteKey, isDisabled = false, children }: HcaptchaProviderProps): JSX.Element => {
  return <HcaptchaContext.Provider value={{ siteKey, isDisabled }}>{children}</HcaptchaContext.Provider>;
};
